const ReloadIcon = ({
  size = 14,
  color = "#3C2212",
  className = "",
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M11.9492 2.05078L12.25 2.32422V0.875C12.25 0.382812 12.6328 0 13.125 0C13.6172 0 14 0.382812 14 0.875V4.375C14 4.86719 13.6172 5.25 13.125 5.25H9.625C9.13281 5.25 8.75 4.86719 8.75 4.375C8.75 3.88281 9.13281 3.5 9.625 3.5H10.9375L10.7188 3.30859V3.28125C8.66797 1.23047 5.33203 1.23047 3.28125 3.28125C1.23047 5.33203 1.23047 8.66797 3.28125 10.7188C5.33203 12.7695 8.66797 12.7695 10.7188 10.7188C10.9375 10.5 11.1289 10.2539 11.3203 10.0078C11.5938 9.59766 12.1406 9.51562 12.5234 9.78906C12.9336 10.0625 13.0156 10.6094 12.7422 10.9922C12.5234 11.3477 12.25 11.6484 11.9492 11.9492C9.21484 14.6836 4.78516 14.6836 2.05078 11.9492C-0.683594 9.21484 -0.683594 4.78516 2.05078 2.05078C4.78516 -0.683594 9.21484 -0.683594 11.9492 2.05078Z"
        fill={color}
      />
    </svg>
  );
};

export default ReloadIcon;
